import React, { Component } from "react";
import { connect } from "react-redux";

import { Switch, Route } from "react-router-dom";
import {
  showBackButton,
  getUserForAuth,
  logoutUser,
} from "../../../actions/authAction";
import {
  fetchProjectNameResis,
  fetchProjectNameComs,
  fetchLocalitys,
} from "../../../actions/nameAction_Ggn";
import ScrollTopButton from "../../scroll/ScrollTopButton";
import ScrollBottomButton from "../../scroll/ScrollBottomButton";
// import ProjectResiDashboard from "../projectResi/ProjectResiDashboard";
// import ProjectComDashboard from "../projectCom/ProjectComDashboard";

import PropResiDashboard from "../propertyResi/PropResiDashboard";
import PropComDashboard from "../propertyCom/PropComDashboard";

import Navbar from "./navbar/Navbar";
import LandingGurgaon from "./LandingGurgaon";

class GurgaonDashboard extends Component {
  componentDidMount() {
    if (this.props.auth.isAuthenticated && !this.props.auth.userA) {
      this.props.getUserForAuth();
    }
    if (this.props.history.location.pathname !== "/") {
      this.props.showBackButton();
    }
    if (this.props.projectNameComs.length < 1) {
      this.props.fetchProjectNameComs();
    }
    if (this.props.projectNameResis.length < 1) {
      this.props.fetchProjectNameResis();
    }
    if (this.props.localitys.length < 1) {
      this.props.fetchLocalitys();
    }
  }
  onLogoutClick = () => {
    this.props.logoutUser();
  };
  render() {
    return (
      <div className="bgColor-gr1" style={{ position: "relative" }}>
        <Navbar/>
        <div style={{ paddingTop: "70px" }} className=" ">
          <Switch>
            <Route exact path="/ggn/" component={LandingGurgaon} />
            {/* <Route path="/ggn/projectR" component={ProjectResiDashboard} />
            <Route path="/ggn/projectC" component={ProjectComDashboard} /> */}

            <Route path="/ggn/propresi" component={PropResiDashboard} />
            <Route path="/ggn/propcom" component={PropComDashboard} /> 
          </Switch>
        </div>

        <ScrollBottomButton />

        <ScrollTopButton />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth,
  projectNameComs: state.ggn_name.projectNameComs,
  projectNameResis: state.ggn_name.projectNameResis,
  localitys: state.ggn_name.localitys,
  state,
});

export default connect(
  mapStateToProps,

  {
    showBackButton,
    getUserForAuth,
    logoutUser,
    fetchProjectNameResis,
    fetchProjectNameComs,
    fetchLocalitys,
  }
)(GurgaonDashboard);
